import httpService from '@/core/http/http.service';
import { createUrlFactory } from '@/project/http/ApiHelper.service';
import { createCancellableGet } from '@/core/http/cancellableGet';
import { RmaInfoViewModel, RmaHeaderViewModel, RmaProfileViewModel, RmaType, AddOrUpdateRmaRequest } from '@/types/apiServerContract';

export class RmaController {
    private readonly urlFactory = createUrlFactory('Rma');

    private cancellableSearchForRMA = createCancellableGet<RmaInfoViewModel>();

    public async getRmaHistory(): Promise<RmaHeaderViewModel> {
        return httpService.get(this.urlFactory('GetRmaHistory'));
    }

    public async getRmaProfile(): Promise<RmaProfileViewModel> {
        return httpService.get(this.urlFactory('GetRmaProfile'));
    }

    public async getRmaInfo(itemId: string, type: RmaType): Promise<RmaInfoViewModel> {
        return this.cancellableSearchForRMA(this.urlFactory('GetRmaInfo'), {
            itemId,
            type
        });
    }

    public async addOrUpdate(request: AddOrUpdateRmaRequest): Promise<RmaProfileViewModel> {
        return httpService.post(this.urlFactory('AddOrUpdate'), request);
    }

    public async create(messagesId: string) {
        return httpService.post(this.urlFactory('Create'), null, messagesId);
    }

    public async clear(messagesId: string): Promise<void> {
        return httpService.post(this.urlFactory('Clear'), null, messagesId);
    }
}
